// SelfLearnerRoutes.js
import React from "react";
import "Common/hooks/StyleFeatures/global.scss"
import { ShopFilled, BookOutlined, UnorderedListOutlined, UserOutlined, CustomerServiceOutlined, } from "@ant-design/icons";
import ExpertLandingPage from "../Components/Dashboard/ExpertLandingPage";
import ExpertProfile from "../Components/Profile/ExpertProfile";
import ProtectedPage from "Common/Components/ProtectedPage";
import ExpertServiceManagement from "../Components/PurchasedServices/ExpertServiceManagment";
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/expert-dashboard",
    icon: <ShopFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/expert-profile">
        <ExpertLandingPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Expert Services",
    key: "expert-services",
    route: "/expert-services",
    icon: <CustomerServiceOutlined  size="12px" />,
    component: (
      <ProtectedPage navigateTo="/expert-profile">
        <ExpertServiceManagement />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  
  // Add Profile route without ProtectedPage (so it's always accessible)
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/expert-profile",
    icon: <UserOutlined size="12px" />,
    component: <ExpertProfile />,
    noCollapse: true,
    hidden: true, // Optional: hide from sidebar
  },
  
];

// Export the profile route separately
export const profileRoute = {
  path: "/expert-profile",
  element: <ExpertProfile />
};

export default routes;